import styled from 'styled-components';
import { Search } from 'theme/icons'; // To match with material ui close icon

export var StyledSearch = styled(Search).withConfig({
  displayName: "SearchBoxstyle__StyledSearch",
  componentId: "sc-oqy2pq-0"
})(["width:14px;height:14px;margin:10px;"]);